angular.module('services.newman.StatesService', [
  'global'
])

/**
 * The StatesService service stores methods used to access
 * system APIs.
 *
 * @class StatesService
 * @constructor
 * @module services.newman.StatesService
 */
.factory('StatesService', [
  '$q',
  '$rootScope',
  '$state',
  'CasesService',
  'DecisionsService',
  'ModelsService',
  'RulesService',
  'SbarWidgetService',
  'studentNotesWidgetService',
  function (
    $q,
    $rootScope,
    $state,
    CasesService,
    DecisionsService,
    ModelsService,
    RulesService,
    SbarWidgetService,
    studentNotesWidgetService
  ) {
    'use strict';

    var service = {

      states: [],

      queue: [],

      titleMap: [],

      /**
       * Returns states.  If a stateId is
       * provided will return a single case.  If no
       * stateId is provided will return all states.
       *
       * @param {string} [stateId] - return only a specific case
       * @param {boolean} [format=false] - flag to format content
       * @return {Object|Array<Object>} All entries
       */
      get: function get(stateId, format) {
        var result;

        service.states = ModelsService.read('states');

        if (stateId) {
          result = _.cloneDeep(ModelsService.find('states', 'id', stateId));
        } else {
          result = service.states;
        }

        if (format) {
          result = {
            label: result.label,
            content: result.content,
            relatives: result.relatives
          };
        }

        return result;
      },

      /**
       * Returns resolved objects from a list of IDs
       *
       * @param {Array<Object>} list - State references
       * @return {Array<Object>} Collection of state objects
       */
      getFromList: function getFromList(list) {
        var states = [];

        _.forEach(list, function (obj) {
          var state = ModelsService.find('states', 'id', obj.id);
          states.push(state);
        });

        service.states = states;

        return service.states;
      },

      /**
       * Creates a new state from provided data
       *
       * @param {string} model - State model
       * @return {Promise<Object>} New state
       */
      create: function create(model) {
        var state = {
          label: model.label,
          content: model.content,
          relatives: model.relatives
        };

        console.log('STATE: ', state);

        return ModelsService.create(ModelsService.find('endpoints', 'label', 'states'), state);
      },

      /**
       * Updates a new state from provided data
       *
       * @param {Object} model - State model
       * @param {Object} data - Data from editing
       * @param {Object} currentCase - Current case
       * @return {Promise<Object>} Updated state
       */
      update: function update(model, data, currentCase) {
        var state = {
          label: data.label,
          content: model.content,
          relatives: data.relatives
        };

        // data = service.dataUpgrade(data);

        var endpoint = ModelsService.find('states', 'id', model.id);

        return ModelsService
          .update(endpoint, state)
          .then(function (response) {
            return $q.all([
              CasesService.addRelative(currentCase, response),
              DecisionsService.update(model.content.decisions[0], data.content.decisions.content),
              RulesService.update(model.content.rules[0], data.content.rules.content)
            ]);
          })
          .catch(function (err) { console.log(err); });
      },

      /**
       * Perform data upgrades if necessary
       *
       * @param {Object} data - State data
       * @return {Object} Upgraded data
       */
      dataUpgrade: function dataUpgrade(data) {
        if (data.content.decisions.content.model === null) {
          data.content.decisions.content.model = data.content.rules.content.decision.model;
        }
        data.content.decisions.content.multiple = data.content.rules.content.decision.multiple;
        data.content.decisions.content.scored = data.content.rules.content.decision.scored;

        return data;
      },

      /**
       * Adds a widget to the state provided
       *
       * @param {Object} stateRef - State to remove the widget from
       * @param {Object} widget - The widget to remove
       * @return {Promise<Object>} Updated state
       */
      addWidget: function addWidget(stateRef, widget) {
        var model = { relatives: stateRef.relatives };

        model.relatives = service.removeRelative(model.relatives, widget.id);

        model.relatives = service.addRelative(model.relatives, widget);

        return ModelsService.update(stateRef, model);
      },

      /**
       * Removes a widget from the state
       *
       * @param {Object} stateRef - State to remove the widget from
       * @param {Object} widget - The widget to remove
       * @return {Promise<Object>} Updated state
       */
      removeWidget: function removeWidget(stateRef, widget) {
        var model = { relatives: stateRef.relatives };

        model.relatives = service.removeRelative(stateRef.relatives, widget);

        return ModelsService.update(stateRef, model);
      },


      /**
       * Adds a relative instance based on
       * provided data
       *
       * @param {Array<Object>} relatives - Array of existing relatives
       * @param {Object} data - Data for new relative
       * @return {Array<Object>} Updated array of relatives
       */
      addRelative: function addRelative(relatives, data) {
        var relative = {};

        relative.id = data.id;
        relative.label = data.label;
        relative.model = data.model;
        relative.href = 'http://localhost:4242/api/v1/' + data.model + '/' + data.id;
        relative.classes = [data.model];

        relatives.push(relative);

        return relatives;
      },

      removeRelative: function removeRelative(relatives, id) {
        return _.reject(relatives, { id: id });
      },

      /**
       * Populate a UI friendly model from pristine
       * state data
       *
       * @param {Object} model - Model template
       * @param {Object} data - Pristine data
       * @return {Object} Model after population of data
       */
      populateModel: function populateModel(model, data) {
        console.log(model, data);
        // return _.merge(model, data);
        return model;
      },

      /**
       * Navigates to state based on provided ID
       *
       * @param {string} stateId - State identifier
       */
      goToState: function goToState(stateId) {
        var endpoint = ModelsService.find('endpoints', 'label', 'events');
        var e;
        var temporaryStateId = stateId;

        if (stateId === '_end') {
          e = {
            label: 'event-' + uuid.v1(),
            content: {
              scored: false,
              end: true,
              type: 'end',
              feedback: null,
              reportId: $rootScope.report.id
            }
          };

          // Only add sbar if widget is enabled for current case
          if (_.some(ModelsService.read('widgets'), 'content.type', 'sbar')) {
            e.content.sbar = SbarWidgetService.model;
          }

          // Only add student notes if widget is enabled for current case
          if (_.some(ModelsService.read('widgets'), 'content.type', 'student notes')) {
            e.content.studentNotes = studentNotesWidgetService.model;
          }

          ModelsService
            .create(endpoint, e)
            .then(function () {
              $state.go('routes.reports', { reportId: $rootScope.report.id }, { reload: true });
              return;
            })
            .catch(function (err) { console.log(err); });
        } else {
          if (stateId === '_self') {
            temporaryStateId = $state.params.stateId;
          }
          if (_.includes($state.current.name, 'routes.cases')) {
            $state.go('routes.cases.states', { stateId: temporaryStateId, mode: null });
          } else {
            $state.go('routes.simulation.states', { stateId: temporaryStateId, mode: null });
          }
        }

        $rootScope.widgetLock = false;
      },

      getStatesListTitleMap: function () {
        return service.titleMap;
      },

      setStatesListTitleMap: function (list) {
        service.titleMap = _.map(list, function (entry) {
          return { value: entry.id, name: entry.label };
        });

        service.titleMap.push({ value: '_end', name: 'End Case' });
      }

    };

    return service;
  }
]);
